import { gsap } from './gsap';

export function initScrollX() {
    document.querySelectorAll( '[data-scroll-x]' ).forEach( ( track ) => {
        const original = track.querySelector( 'img' );
        if ( ! original ) return;

        const speed = parseFloat( track.dataset.scrollSpeed ) || 80; // px/s

        const setup = () => {
            if ( ! original.offsetWidth ) return;

            // Clone until track fills viewport + one extra step for seamless loop
            if ( track.querySelectorAll( 'img' ).length < 2 ) {
                track.appendChild( original.cloneNode( true ) );
            }
            const imgs = track.querySelectorAll( 'img' );
            const step = imgs[ 1 ].offsetLeft - imgs[ 0 ].offsetLeft;

            const needed = Math.ceil( window.innerWidth / step ) + 2;
            for ( let i = imgs.length; i < needed; i++ ) {
                track.appendChild( original.cloneNode( true ) );
            }

            let x = 0;

            gsap.ticker.add( ( _time, deltaTime ) => {
                x -= ( speed * deltaTime ) / 1000;
                if ( x <= -step ) x += step;
                gsap.set( track, { x } );
            } );
        };

        if ( original.complete && original.offsetWidth ) {
            setup();
        } else {
            original.addEventListener( 'load', setup, { once: true } );
        }
    } );
}
